
FWS.Util = (() => {
  
  const assoc = (key, val, obj) => {
    return { ...obj, [key]: val }
  }

  const slice = (arr, i) => {
    return arr && arr.slice ? arr.slice(i) : []
  }

  return {

    safe(promise) {
      return promise.then(d => [ d, null ], e => [ null, e ])
    },

    once(fn) {
      let called = false
      let result = null
      return function(...args) {
        if (called) return result
        result = fn.apply(this, ...args)
        called = true
        return result
      }
    },

    wait(n) {
      return new Promise(res => setTimeout(res, n))
    },

    async waitUntil(test, opts={}) {
      let initialized = false
      while (true) {
        if (test()) break
        if (!initialized && opts.init) opts.init()
        await FWS.Util.wait(200)
      }
    },

    head(arr) {
      return arr[0]
    },

    tail(arr) {
      return arr.slice(1)
    },

    last(arr) {
      return arr[arr.length - 1]
    },

    add(x, y) {
      return x + y
    },

    omit(keys, obj) {
      return Object.entries(obj).reduce((memo, [ k, v ]) => {
        if (keys.includes(k)) return memo
        return { ...memo, [k]: v }
      }, {})
    },

    loadScript(url, key) {
      if (document.getElementById(key))
        return Promise.resolve(window[key])
      return new Promise(res => {
        const script = document.createElement('script')
        script.id = key
        script.onload = () => res(window[key])
        script.src = url
        document.body.appendChild(script)
      })
    },

    debounce(func, timeout = 300){
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    },

    queryToObject(q) {
      return Object.fromEntries(
        new URLSearchParams(q)
      )
    },

    objectToQuery(o) {
      return Object.keys(o).map(key => `${key}=${o[key]}`).join('&')
    },

    assocPath(path, val, obj) {
      switch (path.length) {
        case 0:
          return val;
        case 1:
          return assoc(path[0], val, obj);
        default:
          return assoc(path[0], FWS.Util.assocPath(slice(path, 1), val, Object(obj[path[0]])), obj);
      }
    },

    path(nodes, obj) {
      if (!obj) return null
      return nodes.reduce((current, node) => {
        return current ? current[node] : null
      }, obj)
    },

    deepEqual(a, b) {
      if (Array.isArray(a) && Array.isArray(b))
        return a.length === b.length && a.every(x => b.includes(x))
    }
  }
})()
